<template>
    <v-layout v-if="$can('manage', 'job')">
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{'Job'|translate}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="dialog=true" :disabled="!$can('manage','job')">
                        <v-icon class="mr-2" small>fa-plus</v-icon>
                        {{'Add Job'|translate}}
                    </v-btn>
                    <v-dialog v-model="dialog" max-width="600">
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{'New Job'|translate}}
                            </v-card-title>
                            <v-card-text>

                                <v-form v-model="valid">
                                    <v-select
                                            :items="possibleJobs"
                                            item-text="label"
                                            item-value="name"
                                            label="Job"
                                            v-model="selectedJob"
                                            :rules="[(v) => !!v || 'Job is required']"
                                    ></v-select>
                                    <div v-if="selectedJob">
                                        <p>{{selectedJobDetails.text}}</p>
                                    </div>
                                    <div v-if="selectedJob&&selectedJobDetails.args">
                                        <div v-for="arg in selectedJobDetails.args">
                                            <v-text-field v-if="arg.type==='string'" :label="arg.label" v-model="selectedMeta[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []"></v-text-field>
                                            <v-text-field v-if="arg.type==='number'" type="number" :label="arg.label" v-model.number="selectedMeta[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []"></v-text-field>
                                            <equipment-selector v-if="arg.type==='equipment_name'" :label="arg.label" v-model="selectedMeta[arg.name]" :clearable="!arg.required"></equipment-selector>
                                            <v-text-field v-if="arg.type==='date'" type="date" :label="arg.label" v-model="selectedMeta[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []"></v-text-field>
                                        </div>
                                    </div>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" @click="addJob()" :disabled="!valid">{{'Add'|translate}}</v-btn>
                                <v-btn @click="dialog=false">{{'Cancel'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-card-actions>

                <v-card-text>
                    <v-data-table
                            :headers="headers"
                            :items="points"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.job_id }}</td>
                            <td class="text-xs-left">{{ props.item.job_type }}</td>
                            <td class="text-xs-left">
                                {{props.item.job_status}}
                                <v-alert :value="true" type="error" v-if="props.item.job_status==='error'&&props.item.result&&props.item.result.error_message">
                                    {{ props.item.result.error_message }}
                                </v-alert>
                            </td>
                            <td class="text-xs-left">{{ props.item.meta }}</td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                        small
                                        v-if="$can('manage','job')"
                                        @click="$can('manage','job') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{'No Result Yet'|translate}}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {getJob, deleteJob, putJob,getSupportedJobs} from '../helper'
    import EquipmentSelector from "../components/EquipmentSelector";
    export default {
        name: 'Job',
        components:{EquipmentSelector},
        computed: {
            selectedJobDetails() {
                return this.possibleJobs.filter(x=>x.name===this.selectedJob)[0]
            }
        },
        data(){
            return{
            dialog: false,
            valid:false,
            selectedJob: null,
            selectedMeta: {},
            possibleJobs: [],
            headers: [
                {
                    text: this.$options.filters.translate('Job ID'),
                    align: 'left',
                    sortable: true,
                    value: 'job_id'
                },
                {text: this.$options.filters.translate('Type'), value: 'job_type'},
                {text: this.$options.filters.translate('Status'), value: 'job_status'},
                {text: this.$options.filters.translate('Meta'), value: 'meta', sortable: false},
            ],
            points: [],
            editedIndex: -1,
            editedItem: {},
        }},
        watch: {
            dialog() {
                this.selectedMeta = { };
                this.selectedJob= null
                this.refresh()
            },
            selectedJob() {
                this.selectedMeta = {}
            }
        },
        mounted() {
            this.initialize()
        },
        methods: {
            initialize() {
                this.refresh()
            },
            async deleteItem(item) {
                const index = this.points.indexOf(item)
                if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                    this.points.splice(index, 1)
                    await deleteJob({
                        'job_id': item.job_id
                    })
                    this.refresh()
                }
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },
            async addJob() {
                await putJob({
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'job_type': this.selectedJob,
                    'job_status': 'pending',
                    'meta': this.selectedMeta
                })
                this.dialog = false;
                this.refresh()
            },
            save() {
                if (this.editedIndex > -1) {
                    Object.assign(this.points[this.editedIndex], this.editedItem)
                } else {
                    this.points.push(this.editedItem)
                }
                this.close()
            },
            async refresh() {
                let supportedJobs= await getSupportedJobs()
                this.possibleJobs=supportedJobs.supported_jobs
                let df = await getJob({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                })
                this.points = df['result']
            }
        }
    }
</script>

<style scoped>

</style>
